/*
  Global Snackbar service built on react-native-paper.
  Usage: import { AppSnackbar } from './AppSnackbar';
  Call AppSnackbar.show(message, type?, options?) from anywhere (including Redux).
*/

import { DEFAULT_DURATION } from '../CONSTANTS';

export type SnackbarType = 'info' | 'success' | 'error' | 'warning';

export type AppSnackbarPayload = {
  message: string;
  type?: SnackbarType;
  durationMs?: number;
  actionLabel?: string;
  onAction?: () => void;
};

type HostListener = (payload: AppSnackbarPayload | null) => void;

let hostListener: HostListener | null = null;

export const AppSnackbar = {
  show(
    message: string,
    type: SnackbarType = 'info',
    options?: Omit<AppSnackbarPayload, 'message' | 'type'>,
  ) {
    if (hostListener) {
      hostListener({
        message,
        type,
        durationMs: options?.durationMs ?? DEFAULT_DURATION,
        actionLabel: options?.actionLabel,
        onAction: options?.onAction,
      });
    } else {
      // eslint-disable-next-line no-console
      console.warn('[AppSnackbar] Host not mounted. Message:', message);
    }
  },

  dismiss() {
    if (hostListener) {
      hostListener(null);
    }
  },

  registerHost(listener: HostListener) {
    hostListener = listener;
    return () => {
      if (hostListener === listener) hostListener = null;
    };
  },
};

export default AppSnackbar;
